export class VariantMatrixFilterChangeEvent extends Event {
  static readonly type = 'variant-matrix-filter-change' as const

  constructor(public readonly url: string) {
    super(VariantMatrixFilterChangeEvent.type, { bubbles: true, composed: true })
  }
}

export class VariantMatrixFiltersClearedEvent extends Event {
  static readonly type = 'variant-matrix-filters-cleared' as const

  constructor() {
    super(VariantMatrixFiltersClearedEvent.type, { bubbles: true, composed: true })
  }
}

export type VariantMatrixFilterDraftChange = {
  filterId: number
  optionId: number
  selected: boolean
}

export class VariantMatrixFiltersApplyEvent extends Event {
  static readonly type = 'variant-matrix-filters-apply' as const

  constructor(
    public readonly changes: VariantMatrixFilterDraftChange[],
    public readonly stockOnly: boolean,
  ) {
    super(VariantMatrixFiltersApplyEvent.type, { bubbles: true, composed: true })
  }
}

export class VariantMatrixColumnsAppliedEvent extends Event {
  static readonly type = 'variant-matrix-columns-applied' as const

  constructor(public readonly visibleColumnKeys: string[]) {
    super(VariantMatrixColumnsAppliedEvent.type, { bubbles: true, composed: true })
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [VariantMatrixFilterChangeEvent.type]: VariantMatrixFilterChangeEvent
    [VariantMatrixFiltersClearedEvent.type]: VariantMatrixFiltersClearedEvent
    [VariantMatrixFiltersApplyEvent.type]: VariantMatrixFiltersApplyEvent
    [VariantMatrixColumnsAppliedEvent.type]: VariantMatrixColumnsAppliedEvent
  }
}
